import type { ApiModuleEndpoints } from '../types'

export const webviewApiEndpoints = {
  realtimeBootstrap: { method: 'POST', path: '/realtime/bootstrap', requiresAuth: false },
  // Public (webview khách, định danh bàn qua link_code)
  context: { method: 'GET', path: '/webview/context', requiresAuth: false },
  menu: { method: 'GET', path: '/webview/menu', requiresAuth: false },
  submitOrder: { method: 'POST', path: '/webview/orders', requiresAuth: false },
  history: { method: 'GET', path: '/webview/orders', requiresAuth: false },
  paymentRequests: { method: 'GET', path: '/webview/payment-requests', requiresAuth: false },
  createPaymentRequest: { method: 'POST', path: '/webview/payment-requests', requiresAuth: false },
  // Staff (POS lễ tân)
  staffList: { method: 'GET', path: '/webview-orders', requiresAuth: true },
  staffShow: { method: 'GET', path: '/webview-orders/:id', requiresAuth: true },
  staffAccept: { method: 'POST', path: '/webview-orders/:id/accept', requiresAuth: true },
  staffCancel: { method: 'POST', path: '/webview-orders/:id/cancel', requiresAuth: true },
  staffRemoveItem: { method: 'POST', path: '/webview-orders/items/:item/remove', requiresAuth: true },
  staffRecordRemoval: { method: 'POST', path: '/webview-orders/bill-items/:billItem/record-removal', requiresAuth: true },
  staffPaymentList: { method: 'GET', path: '/webview-orders/payment-requests', requiresAuth: true },
  staffPaymentComplete: {
    method: 'POST',
    path: '/webview-orders/payment-requests/:id/complete',
    requiresAuth: true,
  },
  staffPaymentReject: {
    method: 'POST',
    path: '/webview-orders/payment-requests/:id/reject',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
